import {
  call, put, takeEvery, select, all
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import { actions, actionCreators } from 'react/api/actions/i18n';
import { languageSelector } from 'react/api/selectors/i18n';

export function* fetchResourcesByKeyApi(keys, language) {
  const url = '/I18NResource/restrictions?criteria={"filters":["key","value","i18nlocale.*"]}';
  const encodedUrl = encodeURI(url);
  const data = {
    criteriaChain: [{
      and: [
        { attr: 'module.key', in: ['GreenMileTrack', 'GreenMileCommons'] },
        { attr: 'key', in: keys },
        { attr: 'i18nlocale.language', eq: language }
      ]
    }]
  };
  return yield call(defaultFetch, encodedUrl, data, 'POST');
}

export function* fetchResourcesByKeySaga(action) {
  const language = yield select(languageSelector);
  const keys = action.payload;
  const response = yield call(fetchResourcesByKeyApi, keys, language);
  const { error } = response;
  if (!error) {
    yield put(actionCreators.fetchResourcesByKeySuccess(response));
  }
}

export function* watchFetchResourcesByKey() {
  yield takeEvery(actions.fetchResourcesByKey, fetchResourcesByKeySaga);
}

export default function* () {
  yield all([
    watchFetchResourcesByKey()
  ]);
}
